import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import RepairsPage from "@/pages/RepairsPage";
import FAQPage from "@/pages/FAQPage";
import ContactPage from "@/pages/ContactPage";
import AboutPage from "@/pages/AboutPage";
import TrackJobPage from "@/pages/TrackJobPage";
import PaymentResultPage from "@/pages/PaymentResultPage";
import DashboardLogin from "@/pages/dashboard/DashboardLogin";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import DashboardHome from "@/pages/dashboard/DashboardHome";
import JobDetail from "@/pages/dashboard/JobDetail";
import ScheduleManager from "@/pages/dashboard/ScheduleManager";
import NotificationCenter from "@/pages/dashboard/NotificationCenter";

const PublicRoute = () => (<Layout><Outlet /></Layout>);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public pages with Layout */}
        <Route element={<PublicRoute />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/:slug" element={<ServiceDetailPage />} />
          <Route path="/repairs" element={<RepairsPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/track" element={<TrackJobPage />} />
        </Route>
        {/* Dashboard (no public layout) */}
        <Route path="/dashboard/login" element={<DashboardLogin />} />
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<DashboardHome />} />
          <Route path="jobs/:id" element={<JobDetail />} />
          <Route path="schedule" element={<ScheduleManager />} />
          <Route path="notifications" element={<NotificationCenter />} />
        </Route>
        {/* Payment result (standalone) */}
        <Route path="/payment/result" element={<PaymentResultPage />} />
      </Routes>
      <Toaster position="top-right" richColors theme="dark" />
    </BrowserRouter>
  );
}

export default App;
